'use client'

// Post lightbox for the widget gallery. Mirrors the original vanilla-JS
// behaviour with event delegation: any `.tile.post` click (that isn't on a
// hotspot) opens a panel reading the tile's data-* attributes. Closes on
// backdrop click or Escape.
import { useCallback, useEffect, useState } from 'react'

interface PostData {
  img: string
  handle: string
  plat: string
  caption: string
  product: string
  cta: string
}

export function GalleryLightbox() {
  const [post, setPost] = useState<PostData | null>(null)

  const close = useCallback(() => setPost(null), [])

  useEffect(() => {
    function onClick(e: MouseEvent) {
      const target = e.target as HTMLElement
      if (target.closest('.hot')) return
      const tile = target.closest('.tile.post') as HTMLElement | null
      if (!tile || !tile.closest('.idk-gallery')) return
      const img = tile.querySelector('img')
      setPost({
        img: tile.dataset.img || (img ? img.currentSrc || img.src : ''),
        handle: tile.dataset.handle || 'Creator',
        plat: tile.dataset.plat || 'UGC',
        caption: tile.dataset.caption || '',
        product: tile.dataset.product || '',
        cta: tile.dataset.cta || 'View product',
      })
    }
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') close()
    }
    document.addEventListener('click', onClick)
    document.addEventListener('keydown', onKey)
    return () => {
      document.removeEventListener('click', onClick)
      document.removeEventListener('keydown', onKey)
    }
  }, [close])

  if (!post) return null

  return (
    <div className="idk-gallery">
      <div className="lb on" role="dialog" aria-modal="true" aria-label={`${post.handle} post`}>
        <div className="lb-bg" onClick={close} />
        <div className="lb-card">
          <button className="lb-x" onClick={close} aria-label="Close">
            ×
          </button>
          <div className="lb-media">
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img src={post.img} alt="" />
          </div>
          <div className="lb-side">
            <div className="lb-head">
              <span className="lb-av" />
              <div>
                <div className="lb-handle">{post.handle}</div>
                <div className="lb-plat">{post.plat} · tagged post</div>
              </div>
            </div>
            {post.caption && <div className="lb-cap">{post.caption}</div>}
            {post.product && (
              <div className="lb-prod">
                <span className="lb-pchip">{post.product}</span>
              </div>
            )}
            <a className="btn-primary big lb-cta" href="#">
              {post.cta}
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
